var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@telus-uds/components-web';
import palette from '@telus-uds/palette-koodo';
import styled from 'styled-components';
import { fromLaptop } from '../../../constants/breakpoints';
import { PageSection } from '../../PageSection/PageSection';
var colorThemes = [
    {
        name: 'greenOrangePink',
        backgroundColor: 'green',
        firstCutColor: 'orange',
        secondCutColor: 'pink'
    },
    {
        name: 'orangeGreenPink',
        backgroundColor: 'orange',
        firstCutColor: 'green',
        secondCutColor: 'pink'
    },
    {
        name: 'orangePurpleBlue',
        backgroundColor: 'orange',
        firstCutColor: 'purple',
        secondCutColor: 'pink'
    },
    {
        name: 'blueOrangePink',
        backgroundColor: 'blue',
        firstCutColor: 'orange',
        secondCutColor: 'pink'
    },
    {
        name: 'greenPurpleBlue',
        backgroundColor: 'green',
        firstCutColor: 'purple',
        secondCutColor: 'blue'
    },
    {
        name: 'blueOrangePurple',
        backgroundColor: 'blue',
        firstCutColor: 'orange',
        secondCutColor: 'purple'
    }
];
export var PageTitleStyledCuts = function (_a) {
    var _b;
    var children = _a.children, theme = _a.theme;
    var colorTheme = (_b = colorThemes.find(function (t) { return t.name === theme; })) !== null && _b !== void 0 ? _b : {
        backgroundColor: 'white',
        firstCutColor: 'white',
        secondCutColor: 'white'
    };
    var backgroundColor = colorTheme.backgroundColor, firstCutColor = colorTheme.firstCutColor, secondCutColor = colorTheme.secondCutColor;
    var color = palette.color;
    return (_jsxs(StyledContainer, { bgColor: color[backgroundColor], secondCutColor: color[secondCutColor], children: [_jsx(PageSection, { children: _jsx(StyledBox, { children: _jsxs(Box, { tokens: { backgroundColor: color[backgroundColor] }, right: { lg: 10 }, top: 4, bottom: { xs: 3, md: 5 }, children: [children, _jsx(DesktopStyledFirstCut, { color: color[firstCutColor] })] }) }) }), _jsxs(StyledCuts, { children: [_jsx(StyledFirstCut, { color: color[firstCutColor] }), _jsx(StyledSecondCut, { color: color[secondCutColor] })] })] }));
};
var StyledContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n\n  @media (", ") {\n    background: ", ";\n  }\n"], ["\n  background: ", ";\n\n  @media (", ") {\n    background: ", ";\n  }\n"])), function (props) { return props.bgColor; }, fromLaptop, function (props) {
    return "linear-gradient(90deg, ".concat(props.bgColor, " 0%, ").concat(props.bgColor, " 50%, ").concat(props.secondCutColor, " 50%, ").concat(props.secondCutColor, " 100%)");
});
var StyledCuts = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n\n  @media (", ") {\n    display: none;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n\n  @media (", ") {\n    display: none;\n  }\n"])), fromLaptop);
var StyledBox = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  @media (", ") {\n    margin-right: 140px;\n  }\n"], ["\n  @media (", ") {\n    margin-right: 140px;\n  }\n"])), fromLaptop);
var StyledFirstCut = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 100%;\n  height: 16px;\n  background-color: ", ";\n"], ["\n  width: 100%;\n  height: 16px;\n  background-color: ", ";\n"])), function (props) { return props.color; });
var DesktopStyledFirstCut = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: none;\n\n  @media (", ") {\n    display: block;\n    background-color: ", ";\n    position: absolute;\n    top: 0;\n    right: 0;\n    height: 100%;\n    width: 68px;\n  }\n"], ["\n  display: none;\n\n  @media (", ") {\n    display: block;\n    background-color: ", ";\n    position: absolute;\n    top: 0;\n    right: 0;\n    height: 100%;\n    width: 68px;\n  }\n"])), fromLaptop, function (props) { return props.color; });
var StyledSecondCut = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  width: 100%;\n  height: 32px;\n  background-color: ", ";\n"], ["\n  width: 100%;\n  height: 32px;\n  background-color: ", ";\n"])), function (props) { return props.color; });
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
